// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_j5-0";
export var actionModalContentContainer = "_j5-1";
export var createTagButton = "_j5-2";
export var footerContainer = "_j5-7";
export var fullWidthDivider = "_j5-3";
export var hasCreateTagButton = "_j5-4";
export var noCreateTagButton = "_j5-5";
export var tagsContainer = "_j5-6";
export var tagsModalContentContainer = "_j5-8";